// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"dc3a9f14","408":"b58d2d43","435":"65fae386","583":"8dd7b65a","942":"8b675fac"}[chunkId] + ".chunk.js";
};